import React, { useState, useEffect } from "react";
import { CancelButton, SaveButton, DrawerComponent } from "@comps/components";
import { makeRequest, notify } from "@utils/helpers";
import { createUserReq } from "../requests";

import UserForm from "./UserForm";

const formName = "users";
const CreateUser = (props) => {
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);

  const onFinish = (data) => {
    let payload = {
      "object": {
        ...data,
        is_active: true
      }
    }
    makeRequest(setLoader, createUserReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    notify("User Created", res.msg);
    props.onCreated(data.object);
  }

  const onError = (errors) => {
    setErrors(errors);
  }

  return (
    <DrawerComponent mainTitle="Create" subTitle="User" open={ true } footer={ false } onClose={ () => props.onClosed(false) }>
      <UserForm setErrors={ setErrors } errors={ errors } preData={ {
        roles: props.roles
      } } onFinish={ onFinish } formName={ formName } />
      <div className="form-actions">
        <CancelButton key="close_button" onClick={ () => props.onClosed(false) } />
        <SaveButton form={ formName } key="create_button" htmlType="submit" state={ loader } />
      </div>
    </DrawerComponent>
  );
}

export default CreateUser
